import { Typography } from '@mui/material';

import { convertToDateShort, cleanArrayString } from 'helpers/formatHelper';
import { WorkClaimProps } from 'types/Candidate';

import {
  ReferenceWrapper,
  ReferenceColumn,
  ReferenceCellTextWrapper,
  ReferenceRow,
} from './styledComponents';
export const Reference: React.FC<WorkClaimProps> = ({
  occupation,
  employment_start_date,
  employment_end_date,
  supervisor_given_name,
  supervisor_surname,
  supervisor_email,
  supplied_employer_email,
  supplied_employer_name,
  id,
}) => {
  return (
    <ReferenceWrapper key={id}>
      <Typography variant='h6' textAlign='center'>
        NOT EDITABLE - FOR REFERENCE ONLY
      </Typography>
      <ReferenceRow>
        <ReferenceColumn>
          {ReferenceInfo('Employer Name', supplied_employer_name || '')}
          {ReferenceInfo(
            'Approximate Dates Of Work',
            `${convertToDateShort(
              employment_start_date,
            )} - ${convertToDateShort(employment_end_date)} `,
          )}
          {ReferenceInfo('Occupation', occupation || '')}
        </ReferenceColumn>
        <ReferenceColumn>
          {ReferenceInfo(
            'Employer Email',
            cleanArrayString(supplied_employer_email),
          )}
          {ReferenceInfo(
            'Supervisor Name',
            `${supervisor_given_name || ''} ${supervisor_surname || ''}`,
          )}
          {ReferenceInfo(
            'Supervisor Email',
            cleanArrayString(supervisor_email),
          )}
        </ReferenceColumn>
      </ReferenceRow>
    </ReferenceWrapper>
  );
};

const ReferenceInfo = (title: string, value: string | null) => {
  return (
    <ReferenceCellTextWrapper>
      <Typography variant='overline'>
        <b>{title}</b>
      </Typography>
      <br />
      <Typography>{value ? value.replaceAll(',', ', ') : ''}</Typography>
    </ReferenceCellTextWrapper>
  );
};
